import { canUseExtensions, selectInstitution, selectUser, selectBetaAccesses, selectRooms, } from './selectors';
import { MembershipType } from './types';
import { createSelector } from 'reselect';
import { ACCESS_TYPES } from '../../../account/common/services/access-types';
import { selectinstalledNativeExtensionsWithSettings } from '../../../modules/extensions-framework/selectors';
const isInstitutionAdmin = createSelector(selectUser, (user) => [MembershipType.owner, MembershipType.admin].includes(user.institutionMember?.role));
const isInstitutionOwner = createSelector(selectUser, (user) => [MembershipType.owner].includes(user.institutionMember?.role));
const customAccessMap = {
    [ACCESS_TYPES.MEDICAL_AUDIO]: () => true,
};
const _hasUserAccess = (state, accessKey) => customAccessMap.hasOwnProperty(accessKey)
    ? customAccessMap[accessKey](state)
    : true;
const _hasInstitutionAccess = (state, accessKey) => {
    const institution = selectInstitution(state);
    return institution?.institutionAccess[accessKey];
};
const _hasAccess = (state, accessKey) => _hasUserAccess(state, accessKey) &&
    ![false, null].includes(_hasInstitutionAccess(state, accessKey));
const _hasAtLeastOneAccessFrom = (state, keys) => {
    return keys.some((key) => _hasAccess(state, key));
};
export const hasAccess = (accessKey) => (state) => _hasAccess(state, accessKey);
// keys
export const account_settings_baa = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionAdmin(state);
};
customAccessMap.account_settings_baa = account_settings_baa;
export const accountFeatures_canToggleFeatures = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionAdmin(state);
};
customAccessMap.accountFeatures_canToggleFeatures =
    accountFeatures_canToggleFeatures;
export const roomFeatures_deleteAccount = (state) => {
    const user = selectUser(state);
    return (user.institutionsMemberships.length === 0 ||
        !user.institutionsMemberships.some(({ role }) => role === MembershipType.owner));
};
customAccessMap.roomFeatures_deleteAccount = roomFeatures_deleteAccount;
export const clinicFeatures_manageUsers = (state) => {
    return isInstitutionAdmin(state);
};
customAccessMap.clinicFeatures_manageUsers = clinicFeatures_manageUsers;
export const roomFeatures_billing = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionOwner(state);
};
customAccessMap.roomFeatures_billing = roomFeatures_billing;
export const clinicFeatures_sharedRooms = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionAdmin(state);
};
customAccessMap.clinicFeatures_sharedRooms = clinicFeatures_sharedRooms;
export const clinicFeatures_locations = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionAdmin(state);
};
customAccessMap.clinicFeatures_locations = clinicFeatures_locations;
export const clinicFeatures_landingPageRooms = (state) => {
    const user = selectUser(state);
    return !user.institutionMember || isInstitutionAdmin(state);
};
customAccessMap.clinicFeatures_landingPageRooms =
    clinicFeatures_landingPageRooms;
export const account_settings_team = (state) => {
    const user = selectUser(state);
    return (Boolean(user.institutionMember) &&
        _hasAtLeastOneAccessFrom(state, [
            'clinicFeatures_landingPageRooms',
            'clinicFeatures_sharedRooms',
            'clinicFeatures_locations',
            'clinicFeatures_manageUsers',
            'clinicFeatures_grantRoomAccess',
            'accountFeatures_canToggleFeatures',
        ]));
};
customAccessMap.account_settings_team = account_settings_team;
export const account_settings_extensions = (state) => {
    const extensions = selectinstalledNativeExtensionsWithSettings(state);
    return extensions.length > 0;
};
customAccessMap.account_settings_extensions = account_settings_extensions;
export const account_settings = (state) => {
    return _hasAtLeastOneAccessFrom(state, [
        'account_settings_extensions',
        'account_settings_general',
        'account_settings_team',
        'account_settings_baa',
    ]);
};
customAccessMap.account_settings = account_settings;
export const account_marketplace = (state) => {
    return canUseExtensions(state);
};
customAccessMap.account_marketplace = account_marketplace;
export const account_settings_personal_and_professional_info = (state) => {
    return _hasAtLeastOneAccessFrom(state, ['roomFeatures_editPersonalInfo']);
};
customAccessMap.account_settings_personal_and_professional_info =
    account_settings_personal_and_professional_info;
export const account_roomFeatures_modifyRoomSettings = (state) => {
    return _hasAtLeastOneAccessFrom(state, ['roomFeatures_modifyRoomSettings']);
};
customAccessMap.account_roomFeatures_modifyRoomSettings =
    account_roomFeatures_modifyRoomSettings;
export const account_settings_general = (state) => {
    return _hasAtLeastOneAccessFrom(state, [
        'roomFeatures_changeLoginInfo',
        'roomFeatures_deleteAccount',
        'roomFeatures_billing',
    ]);
};
customAccessMap.account_settings_general = account_settings_general;
export const inviteFeatures_badge = (state) => {
    const user = selectUser(state);
    return (!user.institutionMember || _hasAccess(state, 'roomFeatures_createBadge'));
};
customAccessMap.inviteFeatures_badge = inviteFeatures_badge;
export const toggle_extensions_teleconsent = createSelector(selectBetaAccesses, (betaAccesses) => betaAccesses.teleconsent);
customAccessMap.toggle_extensions_teleconsent = toggle_extensions_teleconsent;
export const toggle_extensions_scheduling = createSelector(selectBetaAccesses, (betaAccesses) => betaAccesses.scheduling);
customAccessMap.toggle_extensions_scheduling = toggle_extensions_scheduling;
export const notifications_room_type = (state) => {
    const institution = selectInstitution(state);
    const rooms = selectRooms(state);
    return (Boolean(institution) &&
        rooms.length > 1 &&
        _hasAtLeastOneAccessFrom(state, [
            'notifications_browserAlert',
            'notifications_emailAlert',
            'notifications_textMessage',
        ]));
};
customAccessMap.notifications_room_type = notifications_room_type;
